import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import translationDe from '../translations/de.json';
import translationEn from '../translations/en.json';

i18n.use(initReactI18next).init({
    resources: {
        de: { translation: translationDe },
        en: { translation: translationEn },
    },
    lng: 'de',
    fallbackLng: 'en',
    interpolation: {
        escapeValue: false,
    },
});

export default i18n;
